import { Tooltip } from '@material-ui/core';
import {
  ColorDark,
  ColorDynamic,
  Column,
  Columns,
  Image,
  Inline,
  Stack,
} from '@superdispatch/ui';
import { Button, TextBox } from '@superdispatch/ui-lab';
import styled, { css } from 'styled-components';
import { CheckIconBold } from '../../../icons/CheckIconBold';
import { PricingInsightsIcon } from '../../../icons/PricingInsightsIcon';
import { useUnlockUtils } from '../unlock/UnlockUtils';
import demoDataImg from './assets/demo_data.png';
import demoDataImgDark from './assets/demo_data_dark.png';
import { dismissDemoData } from './DemoDataUtils';
import { DescriptionTooltipContent } from './DescriptionTooltipContent';

const Container = styled.div(({ theme }) => {
  const isDark = theme.palette.type === 'dark';

  return css`
    position: relative;
    display: flex;
    gap: 16px;
    padding: 16px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid ${ColorDynamic.Silver400};

    > * {
      position: relative;
    }

    &::before {
      content: '';
      position: absolute;
      top: -50px;
      left: -100px;
      width: 250px;
      height: 200px;
      border-radius: 50%;
      background: ${
        isDark
          ? ColorDark.White
          : `linear-gradient(
            124deg,
            #d7cbe0 42.36%,
            rgba(149, 1, 173, 0) 87.4%
          )`
      };
      opacity: 0.4;
      filter: blur(50px);
    }
  `;
});

const ListItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;

  svg {
    margin-top: 2px;
  }
`;

const TooltipTitle = styled(TextBox)`
  text-decoration: dashed underline ${ColorDynamic.Silver500};
  text-underline-offset: 4px;
  cursor: pointer;

  &:hover {
    color: ${ColorDynamic.Blue500};
    text-decoration: dashed underline ${ColorDynamic.Blue500};
  }
`;

export function DemoBanner() {
  const { usagesLeft } = useUnlockUtils();

  return (
    <Container>
      <Stack>
        <Columns
          space="small"
          collapseBelow="tablet"
          reverse={[true, false, false]}
          align={['center', 'top', 'top']}
        >
          <Column>
            <Stack space="small">
              <Inline verticalAlign="center">
                <PricingInsightsIcon
                  fontSize="small"
                  htmlColor={ColorDynamic.Dark300}
                />
                <TextBox variant="heading-4">Explore with Demo Data</TextBox>
              </Inline>

              <Stack>
                <ListItem>
                  <CheckIconBold
                    fontSize="small"
                    htmlColor={ColorDynamic.Dark300}
                  />
                  <TextBox>
                    Explore <b>without using your insights.</b>
                  </TextBox>
                </ListItem>
                <ListItem>
                  <CheckIconBold
                    fontSize="small"
                    htmlColor={ColorDynamic.Dark300}
                  />
                  <TextBox>
                    Data shown is sample data, not live market trends.
                  </TextBox>
                </ListItem>
              </Stack>
            </Stack>
          </Column>
          <Column width="content">
            <Image
              width={155}
              src={demoDataImg}
              srcDark={demoDataImgDark}
              alt="Demo Data image"
            />
          </Column>
        </Columns>
        <Inline space="small" verticalAlign="center">
          <Button variant="primary" onClick={dismissDemoData}>
            Try with Your Shipping Details
          </Button>
          <Tooltip
            arrow={true}
            placement="top"
            interactive={true}
            title={<DescriptionTooltipContent />}
          >
            <TooltipTitle variant="hint">
              {usagesLeft} free insights available
            </TooltipTitle>
          </Tooltip>
        </Inline>
      </Stack>
    </Container>
  );
}
